import * as angular from 'angular';
import controller from './topRejectsGraph.controller';
import template from './topRejectsGraph.tpl.html';

export default angular
  .module('aps.directive.topRejectsGraph', [controller])
  .directive('apsTopRejectsGraph', topRejectsGraphDef)
  .name;

function topRejectsGraphDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'TopRejectsGraphCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      model: '=',
      interval: '=',
      equipmentSelected: '='
    },
    link: function ($scope: any, elm: any, attrs: any) {
      $scope.vm.setShift($scope.vm.interval);
      $scope.vm.model.equipmentGroups.forEach((group, i) => {
        if (group.hasRejects) {
          $scope.$watch('vm.model.equipmentGroups[' + i + '].rejectCount', () => $scope.vm.renderChart());
        }
      });
      $scope.vm.renderChart();
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/dashboard/topRejectsGraph.directive.ts